module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"defineColumns":"Define Columns"},"de":{"defineColumns":"Column definieren"}}')
  delete Component.options._Ctor
}
